const theme = {
  colors: {
    noissuePink: '#ff516e',
    noissuePurple: '#393972'
  }
};

export default theme;